import { Box, createTheme, Typography } from "@mui/material";

export const blue = "#011949";
export const yellow = "#FEBC2E";
export const textColor = "#1F1F1F";

export const fontTitle = { fontWeight: 700, fontSize: '36px', lineHeight: '48px' };
export const fontText = { fontWeight: 400, fontSize: '18px', lineHeight: '28px' };

export const Logo = ({ sx = {} }) => {
    return <Box component={'a'} href="/" sx={{ textDecoration: 'none' }}><Typography sx={{ fontFamily: 'alexandria', ...fontTitle, color: 'white', ...sx }}><span style={{ color: yellow }}>Čistí</span>doma.cz</Typography></Box>;
}

const themeData = {
    components: {
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    text: "p",
                    title: "h1",
                },
            },
            styleOverrides: {
                root: ({ ownerState }) => ({
                    color: textColor,
                    textTransform: "none",
                    textDecoration: 'none',
                    fontFamily: 'inter',
                }),
            },
        },
        typography: {
            useNextVariants: true,
        },
    }
};

export const theme = createTheme(themeData);
